import React from 'react'

export default function Footer() {
    return(
        <div className="footer">
           <p> &copy; 2022 KEN Yakitori Bar All Right Reserved </p> 
        </div>
    )
}